import { GridColumn, GridColumnType } from "@/components/child/grid/gridColumn";
import { Component } from "@/decorators";
import CorModel from "@/models/corModel";
import corService from "@/services/corService";

import ListComponentBase from "../listComponentBase";

@Component
export default class CoresListComponent extends ListComponentBase<CorModel> {
    get gridColumns(): Array<GridColumn> {
        return [new GridColumn("descricao", this.$t("__.ts.descricao"), GridColumnType.String)];
    }

    private beforeMount() {
        this.setPropsCached(corService, "cor", "descricao");
    }
}
